import React, { useEffect, useState } from "react";
import cookie from "react-cookies";
import { getLiveShiftInvites, rsvpLiveShift } from "../../services/academyApi";
import { TrainingLoading } from "../academy/AcademyShared";
import MeLayout from "./MeLayout";

function formatWhen(invite) {
  if (!invite?.day_date) return "Date to be confirmed";
  const date = new Date(`${String(invite.day_date).slice(0, 10)}T12:00:00`);
  const dateText = date.toLocaleDateString("en-ZA", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  const start = String(invite.starts_at || "08:00").slice(0, 5);
  const end = String(invite.ends_at || "17:00").slice(0, 5);
  return `${dateText}, ${start} to ${end}`;
}

function formatRand(cents) {
  return `R${Math.round((Number(cents) || 0) / 100)}`;
}

function statusLabel(status) {
  switch (status) {
    case "invited":
      return "RSVP needed";
    case "accepted":
      return "You are coming";
    case "declined":
      return "Declined";
    case "attended":
      return "Attended";
    case "paid":
      return "Stipend paid";
    case "no_show":
      return "Marked as no show";
    default:
      return status;
  }
}

export default function MeLiveShift() {
  const [invites, setInvites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busyId, setBusyId] = useState(null);
  const [error, setError] = useState("");

  const load = () => {
    if (!cookie.load("candidateKey")) {
      window.location.href = "/login?next=/me/live-shift";
      return;
    }
    setLoading(true);
    getLiveShiftInvites()
      .then((res) => setInvites(res.invites || []))
      .catch(() => setInvites([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
  }, []);

  const rsvp = async (inviteId, status) => {
    setBusyId(inviteId);
    setError("");
    try {
      const res = await rsvpLiveShift(inviteId, status);
      setInvites((prev) =>
        prev.map((item) => (item.id === inviteId ? res.invite : item))
      );
    } catch (err) {
      setError(err.message || "Could not save your RSVP.");
    } finally {
      setBusyId(null);
    }
  };

  return (
    <MeLayout title="Live Shift Interview">
      <p className="training-lead">
        A full day in the QikTruck control room. You process live customer
        bookings and driver jobs with the team. You earn {formatRand(50000)} for
        the day after you attend. This is a working interview, not a job offer.
      </p>

      {loading ? (
        <TrainingLoading label="Loading your invitations..." />
      ) : invites.length === 0 ? (
        <div className="training-empty">
          <p>
            You do not have a Live Shift invitation yet. Finish your training
            modules so the team can invite you.
          </p>
        </div>
      ) : (
        <div className="live-shift-list">
          {error ? <p className="training-feedback training-feedback-error">{error}</p> : null}
          {invites.map((invite) => (
            <article key={invite.id} className="live-shift-card">
              <div className="live-shift-card__kicker">{statusLabel(invite.status)}</div>
              <h2 className="live-shift-card__title">{invite.title || "Live Shift Interview"}</h2>
              <ul className="live-shift-card__meta">
                <li>{formatWhen(invite)}</li>
                <li>{invite.venue}</li>
                <li>{formatRand(invite.stipend_cents)} stipend after attendance</li>
              </ul>
              {invite.brief ? <p className="live-shift-card__brief">{invite.brief}</p> : null}
              <div className="live-shift-card__rules">
                <p>On the day you will:</p>
                <ul>
                  <li>Sit with HQ and handle live customer orders</li>
                  <li>Talk to drivers, update jobs, and keep notes</li>
                  <li>Treat customer and driver details as confidential</li>
                </ul>
                <p>Bring your ID. Dress neatly for office work. Arrive 10 minutes early.</p>
              </div>
              {(invite.status === "invited" ||
                invite.status === "accepted" ||
                invite.status === "declined") &&
              invite.day_status === "scheduled" ? (
                <div className="live-shift-card__actions">
                  <button
                    type="button"
                    className="training-btn-primary"
                    disabled={busyId === invite.id || invite.status === "accepted"}
                    onClick={() => rsvp(invite.id, "accepted")}
                  >
                    {invite.status === "accepted" ? "You are coming" : "I will be there"}
                  </button>
                  {invite.status !== "declined" ? (
                    <button
                      type="button"
                      className="training-btn-secondary"
                      disabled={busyId === invite.id}
                      onClick={() => rsvp(invite.id, "declined")}
                    >
                      I cannot make it
                    </button>
                  ) : null}
                </div>
              ) : null}
            </article>
          ))}
        </div>
      )}
    </MeLayout>
  );
}
